/* ==========================================================================
   HOME PASSION · nokta sayfalama

   Yatay kayan siralarin altina nokta koyar, kaydirdikca aktif olani isaretler.

   Iki tasarim karari:
   · Noktalar HER ZAMAN kurulur; kaymayan (masaustu izgara) durumda
     .hp-dots--off ile gizlenir. matchMedia'ya bagli degil.
   · 'scroll' olayina GUVENMEZ. Bu temada olayin tetiklenmedigi durumlar
     olcumle gorulmustur; bu yuzden gorunurken 220ms'de bir scrollLeft
     karsilastirilir. Gorus disindayken tamamen durur.
   ========================================================================== */
(function(){
  'use strict';

  function build(scroller){
    if(!scroller || scroller.dataset.hpDots) return;
    scroller.dataset.hpDots = '1';

    var dots = document.createElement('div');
    dots.className = 'hp-dots hp-dots--off';
    dots.setAttribute('aria-hidden','true');
    scroller.parentNode.insertBefore(dots, scroller.nextSibling);

    var lastX = -1, lastN = -1, timer = null, seen = false;

    function render(force){
      var n = scroller.children.length;
      var x = scroller.scrollLeft;
      if(!force && x === lastX && n === lastN) return;
      lastX = x; lastN = n;

      if(!n){ dots.innerHTML = ''; dots.classList.add('hp-dots--off'); return; }

      if(dots.children.length !== n){
        dots.innerHTML = '';
        for(var i=0;i<n;i++){ dots.appendChild(document.createElement('i')); }
      }

      if(scroller.scrollWidth - scroller.clientWidth <= 2){
        dots.classList.add('hp-dots--off');
        return;
      }
      dots.classList.remove('hp-dots--off');

      var sr = scroller.getBoundingClientRect(), best = 0, bestVis = -1e9;
      for(var j=0;j<n;j++){
        var r = scroller.children[j].getBoundingClientRect();
        var vis = Math.min(r.right, sr.right) - Math.max(r.left, sr.left);
        if(vis > bestVis){ bestVis = vis; best = j; }
      }
      for(var k=0;k<n;k++){
        dots.children[k].classList.toggle('on', k === best);
      }
    }

    function start(){ if(!timer){ timer = setInterval(function(){ render(false); }, 220); } }
    function stop(){ if(timer){ clearInterval(timer); timer = null; } }

    /* olay gelirse hemen tepki ver — gelmezse yoklama zaten yakalar */
    scroller.addEventListener('scroll', function(){ render(false); }, {passive:true});
    ['pointerup','touchend','wheel'].forEach(function(ev){
      scroller.addEventListener(ev, function(){ setTimeout(function(){ render(true); }, 160); }, {passive:true});
    });
    addEventListener('resize', function(){ render(true); }, {passive:true});
    addEventListener('orientationchange', function(){ render(true); }, {passive:true});

    if('IntersectionObserver' in window){
      new IntersectionObserver(function(es){
        es.forEach(function(e){
          seen = e.isIntersecting;
          if(seen){ render(true); start(); } else { stop(); }
        });
      }, {rootMargin:'120px'}).observe(scroller);
    } else { start(); }

    [250, 900, 2200, 4000].forEach(function(ms){ setTimeout(function(){ render(true); }, ms); });
    render(true);
  }

  function boot(root){
    (root || document).querySelectorAll('.hp-duo-grid, .hp-revs').forEach(build);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ boot(); });
  } else { boot(); }
  document.addEventListener('shopify:section:load', function(e){ boot(e.target); });
  addEventListener('load', function(){ boot(); });
})();
